import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface ILocation {
  id: number
  main: boolean
  name: string
  country: string
  country_label: string | null
  company_id: number
  phone_number: string | null
  state: string | null
  city: string | null
  address_line_1: string | null
  address_line_2: string | null
  postal_code: string | null
  latitude: unknown
  longitude: unknown
  timezone: string | null
  radius?: number | null
  siret?: string | null
}

class Location extends Model<ILocation> {
  static urlRoot() {
    return '/locations'
  }
  constructor(attr: ILocation) {
    super(attr)
    makeObservable(this, {
      isMainLocation: computed,
      timezone: computed,
      isTimezoneEmpty: computed,
    })
  }
  get id(): number {
    return this.attributes.id
  }

  get isMainLocation(): boolean {
    return this.attributes.main
  }
  get timezone(): string | null {
    return this.attributes.timezone
  }
  get isTimezoneEmpty(): boolean {
    return !this.timezone
  }
  get name(): string {
    return this.attributes.name
  }
  get country(): string {
    return this.attributes.country
  }
}

export default Location
